/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DelegateQuestionnaire = {
  delegatee_email: string;
  delegatee_name: string;
  notification_preference?: DelegateQuestionnaire.notification_preference;
  /**
   * Optional list of specific Question IDs to delegate. If not provided, delegates all questions.
   */
  question_ids?: Array<number>;
  /**
   * Optional list of specific RequestedFile IDs to delegate from the paired document request. If not provided, delegates all files.
   */
  requested_file_ids?: Array<number>;
};
export namespace DelegateQuestionnaire {
  export enum notification_preference {
    EACH_ANSWER = 'each_answer',
    ALL_COMPLETE = 'all_complete',
    NONE = 'none',
  }
}

